import { parseRecalledPrompt } from '#pplx/frontend/apps/ask/ask-input/ask-input-core/hooks/internal/recalledPrompt.js';
import { usePromptHistoryInputHandlers } from '#pplx/frontend/apps/ask/ask-input/ask-input-core/hooks/usePromptHistoryInputHandlers.js';
import { useMemo } from 'react';
export function useThreadPromptHistory({ results, value, setValue, onChange, onSubmit, trackEvent, resetKey, }) {
    const promptHistory = useMemo(() => [...results]
        .reverse()
        .filter((entry) => entry.query_str && !entry.trigger)
        .map((entry) => parseRecalledPrompt(entry.query_str ?? '')), [results]);
    const handlers = usePromptHistoryInputHandlers({
        history: promptHistory,
        value,
        setValue,
        onChange,
        onSubmit,
        trackEvent,
        resetKey,
    });
    return useMemo(() => ({ ...handlers, promptHistory }), [handlers, promptHistory]);
}
//# sourceMappingURL=useThreadPromptHistory.js.map